import { render, staticRenderFns } from "./BuyNowButton.vue?vue&type=template&id=c6aac960"
import script from "./BuyNowButton.vue?vue&type=script&lang=ts"
export * from "./BuyNowButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports